import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=c759ded2&scoped=true&lang=html&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c759ded2",
  null
  
)

export default component.exports